/**
 * Shared Blob helpers (TICKET-281f).
 *
 * Originated as a private helper inside `diceRegistryService.ts`; promoted to a
 * shared util so the Discord branch in `RollPage.tsx` can reuse it without a
 * duplicate copy.
 */

/**
 * Convert a Blob to a base64-encoded string (no data-URI prefix).
 *
 * Used wherever binary captures (images, videos) need to ride a JSON request.
 * The data-URI prefix is stripped because backend handlers accept either form
 * but most call sites prefer the bare base64.
 *
 * @param blob - Source blob (image, video, etc.)
 * @returns Promise resolving to the bare base64 string
 */
export async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const dataUrl = reader.result as string;
      const comma = dataUrl.indexOf(',');
      resolve(comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl);
    };
    reader.onerror = () => reject(new Error('Failed to read blob'));
    reader.readAsDataURL(blob);
  });
}
